import { environment } from 'src/environment';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { COUPON, VOUCHER } from '../../constants/key.constants';
import { R_ACCOUNT_SETTINGS } from 'src/app/shared/constants/route.constants';
import { SessionService } from 'src/app/core/services/session.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { SignupStepComponent } from '../signup-step/signup-step.component';
import { CardPlanComponent } from '../card-plan/card-plan.component';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-select-plan',
  templateUrl: './select-plan.component.html',
  styleUrls: ['./select-plan.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, SignupStepComponent, CardPlanComponent]
})
export class SelectPlanComponent implements OnInit {

  backRoute = window.innerWidth > 768 ? '/home' : '/account/m/home';
  currentStep = 2;
  subscriptions: any;
  buttonValue: string;
  @Input() oldUser = false;
  @Input() paymentDialog = false;
  @Input() discountFlag: boolean;
  selectedPlan;
  @Output() emitSelectPlan?= new EventEmitter<{ session_id: string, coupon_valid?: String, paymentMethods?: [], freePlan?: Number }>();
  @Output() emitStep = new EventEmitter<Number>();
  @Input() page;
  @Input() planData;
  livePaymentPage;
  @Input() paymentTypes;
  @Input() type;
  avodPlans;
  svodPlans;
  couponPlan = false;
  currentPlan: any;
  isAvodSubscribed: boolean;
  innerWidth: number;
  isMobileScreen: boolean;
  enableFlag: boolean = false;
  @Input() pageWiseFlow; // flag to check whether it is from auth/plan page or not
  planId: any;
  oldButtonValue: string;
  email;
  allPlans;
  paymentDialogStore = false;
  paymentGateway: any;

  skinName = environment.skinName;
  constructor(private subscriptionService: SubscriptionService, public baseService: BaseService,
    public planService: PlanService, private storageService: StorageService,
    private router: Router, private uikitService: UikitService, private settingsService: SettingsService,
    public configService: ConfigurationService, private route: ActivatedRoute,
    private datalayerService: DatalayerService, private el: ElementRef, private renderer: Renderer2, private analyticsService: InhouseAnalyticsService) {
  }

  async ngOnInit(): Promise<void>{
    this.paymentGateway = this.settingsService.paymentGateway;
    this.buttonValue = (this.configService.localeKeys?.["plans.please_wait.text"] || 'Please wait');

    this.planId = this.route.snapshot.queryParams.plan_id;
    this.couponPlan = false;
    this.livePaymentPage = this.page;
    const paywallQueryParams = this.route.snapshot.queryParams;
    this.email = paywallQueryParams?.email;
    if(this.planService.plansLength>0) await this.fetchUserPlan();
    else this.paymentDialogStore = true;
    const prevPaymentPathName = location.href;
    this.storageService.setLocalStore('prevPaymentPathName', prevPaymentPathName);
    this.checkVoucherApplied();
  }

  @HostListener('window.resize', ['$event'])
  onResize(event) {
    this.backRoute = window.innerWidth > 768 ? '/home' : '/account/m/home';
    this.checkVoucherApplied();
  }

  async fetchUserPlan(): Promise<void> {
    const u_id = this.storageService.getLocalStore('u_id');
    let guest;
    this.baseService.guest.subscribe(data => guest = data);
  
    // as per prjct_081: plans page should be shown before signup page
    if (u_id || (guest && (this.router.url.includes('auth/plan') || this.router.url.includes('voucher/plan')))) {
      if (this.page == 'account' && this.planData) {
        this.userPlanData(this.planData);
      } else {
        try {
          const data = await this.subscriptionService.userPlan().toPromise();
          this.allPlans = data;
          this.paymentDialogStore = true;
          if (data) {
            this.userPlanData(data);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.baseService.loaderSource.next(false);
        }
      }
    }
  }

  userPlanData(data) {
    const u_id = this.storageService.getLocalStore('u_id');
    this.buttonValue = (data?.free_trial_days > 0) ? data?.free_trial_text : (this.configService.localeKeys?.["plans.proceed.text"] || 'Proceed');
    this.storeFreeTrialInfo(data);

    this.avodPlans = data.plans.filter(plan => plan.with_ads === 1);
    this.svodPlans = data.plans.filter(plan => plan.with_ads === 0);
    this.subscriptionService.subsData = data;
    this.subscriptions = data.plans;

    let index;
    if (this.planId) {
      // Getting selected plan index to show selected when navigated from paywall(on click of plan realted buttons)
      index = this.subscriptions.findIndex((plan) => plan.subscription_id === this.planId);
    } else {
      // Getting selcted plan index to show selected plan when naviagted back in payment flow
      const userselectedPlan = this.storageService.getSessionStore('selectedPlanData');
      if (userselectedPlan) index = this.subscriptions.findIndex((plan) => { return plan.subscription_id === userselectedPlan?.subscription_id });
    }
    if (index > 0) {
      this.subscriptions[index].isSelected = true;
      this.selectedPlan = this.subscriptions[index];
      this.enableFlag = true;
      const discountCoupon = this.storageService.getLocalStore('discount_code');
      const discountType = this.storageService.getLocalStore('discount_type');
      if (discountCoupon && discountType === COUPON) {
        this.couponPlan = true;
      } else {
        this.couponPlan = false;
      }
      if (this.selectedPlan.free_plan) this.buttonValue = this.configService.localeKeys?.["plans.proceed.text"] || 'Proceed'; // for freen plan there wont be trial, So button name is changed
      else {
        this.buttonValue = this.selectedPlan.free_trial_days > 0 ? this.selectedPlan?.free_trial_text : (this.configService.localeKeys?.["plans.proceed.text"] || 'Proceed');
        this.storeFreeTrialInfo(this.selectedPlan);
      }
    }

    if (data?.subscribed_plan_id) {
      this.currentPlan = this.subscriptions.find(plan => plan.subscription_id == data?.subscribed_plan_id);
      this.isAvodSubscribed = this.currentPlan?.with_ads ? false : true;
      this.selectedPlan = this.currentPlan;
    }
    if (!this.subscriptions?.length && this.router.url.match('plan')) this.router.navigateByUrl('/home');
    if (this.subscriptionService.planDetails?.plan) {
      this.subscriptions.forEach(plan => {
        if (this.subscriptionService.planDetails.plan.id === plan.id) {
          plan['popular_status'] = 1;
        } else {
          plan['popular_status'] = 0;
        }
      });
    }
    if (this.avodPlans?.length === 1) {
      const planDetail = document.getElementById('avod-plan-details');
      if (planDetail) planDetail.style.gridTemplateColumns = 'auto';
    }
    if (this.svodPlans?.length === 1) {
      const planDetail = document.getElementById('svod-plan-details');
      if (planDetail) planDetail.style.gridTemplateColumns = 'auto';
    }
    let popularAvailable = false;
    this.subscriptions.forEach(plan => {
      if (plan.popular_status == 1) {
        popularAvailable = true;
        const datalayerData = {
          event: 'GAEvent',
          eventCategory: 'Payment',
          eventAction: 'View',
          eventLabel: plan.popular_status == 1 ? plan.title : '',
          platform: this.baseService.browserType,
          loginStatus: 'True',
          userId: (u_id ? u_id : ''),
          notificationStatus: localStorage.getItem('emailNotify') || 'False',
          region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
          userType: this.storageService.getLocalStore('user_type'),
        };
        this.datalayerService.addDatalayer(datalayerData);
      }
    });
    if (!popularAvailable && this.subscriptions.length) {
      this.subscriptions[0].popular_status = 1;
      const datalayerData = {
        event: 'GAEvent',
        eventCategory: 'Payment',
        eventAction: 'View',
        eventLabel: this.subscriptions[0].title,
        platform: this.baseService.browserType,
        loginStatus: 'True',
        userId: (u_id ? u_id : ''),
        notificationStatus: localStorage.getItem('emailNotify') || 'False',
        region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
        userType: this.storageService.getLocalStore('user_type'),
      };
      this.datalayerService.addDatalayer(datalayerData);
    }
    const { one_time_subscription, user_type } = data
    if (user_type || one_time_subscription || this.discountFlag) {
      if (!this.discountFlag) this.subscriptionService.oldUser, this.oldUser = true;
    }
  }

  selectPlan(i, plan, planType) {
    if (window.innerWidth <= 470) {
      const url = window.location.href;
      if (url.includes('account') || url.includes('home') || url.includes('video') || url.includes('series') || url.includes('live')) {
        const selectPlanPad = this.el.nativeElement.querySelector('#select-plan-pad');
        if (selectPlanPad) {
          this.renderer.setStyle(selectPlanPad, 'height', '200px'); // Set the height to 200px
          this.renderer.setStyle(selectPlanPad, 'margin-bottom', '200px'); // Set the margin-bottom to 20px
          this.renderer.setStyle(selectPlanPad, 'overflow-y', 'scroll'); // Set overflow-y to scroll
        }
      }
    }
    const discountCoupon = this.storageService.getLocalStore('discount_code');
    const discountType = this.storageService.getLocalStore('discount_type');
    this.svodPlans.forEach(obj => obj.isSelected = false);
    this.avodPlans.forEach(obj => obj.isSelected = false);
    if (planType === 'avod') {
      this.avodPlans[i].isSelected = true;
    } else {
      this.svodPlans[i].isSelected = true;
    }
    this.selectedPlan = plan;
    this.enableFlag = true
    if (discountCoupon && discountType === COUPON) {
      this.couponPlan = true;
    } else {
      this.couponPlan = false;
    }
    if (this.selectedPlan.free_plan) this.buttonValue = this.configService.localeKeys?.["plans.proceed.text"] || 'Proceed'; // for free plan there wont be trial, So button name is changed
    else {
      this.buttonValue = this.selectedPlan.free_trial_days > 0 ? this.selectedPlan?.free_trial_text : (this.configService.localeKeys?.["plans.proceed.text"] || 'Proceed');
      this.storeFreeTrialInfo(this.selectedPlan);
    }
    this.oldButtonValue = this.buttonValue;
    // for alliance subscription submit button name
    if (this.selectedPlan?.type_of_plan === 'alliance_plan') this.buttonValue = this.configService.localeKeys?.["plans.select_plan.text"];
    else this.buttonValue = this.oldButtonValue;
  }

  storeFreeTrialInfo(data) {
    // Storing free trial days free trial text in localstorage as those values used on other components
    this.storageService.setLocalStore('freeTrialDays', data?.free_trial_days);
    if (data?.free_trial_days > 0) this.storageService.setLocalStore('freeTrialText', data?.free_trial_text);
    else this.storageService.removeLocalStore('freeTrialDays');
  }

  onPlanSubmit() {
    if (this.selectedPlan) {
      const discountCoupon = this.storageService.getLocalStore('discount_code');
      const userType = this.storageService.getLocalStore('user_type');
      const eventObj = {
        event_type: 'event',
        event_name: 'Plan Selected',
        event_status: 'Success',
        discount_code: discountCoupon || '',
        value: this.selectedPlan.amount,
        payment_type: this.paymentGateway,
        subscription_status: userType,
        paid_user: userType,
        subscription_plan: this.selectedPlan.title
      };
      this.analyticsService.trackUserActions(eventObj);
    }
    // When no plan is selected
    if (!this.selectedPlan) {
      const selectPlanErr = this.configService.localeKeys?.["plans.select_a_plan.text"] || 'Please Select a Plan';
      this.uikitService.staticErrorMessage(selectPlanErr);
      return;
    }
    // when selected plan is alliance_plan redirect to redirection_url sent in api response
    if (this.selectedPlan.type_of_plan === 'alliance_plan') {
        window.open(this.selectedPlan?.redirection_url, '_blank');
        return;
    }
    // as per prjct:081 for non loggedin user plans will be shown first and after selecting plan signup page should be shown
    this.storageService.setSessionStore('selectedPlanData', this.selectedPlan);
    const uId = this.storageService.getLocalStore('u_id');
    if (this.pageWiseFlow && !uId && this.selectedPlan.type_of_plan === 'normal_plan') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          email: this.email
        }
      }
      this.planService.freeTrialDays = this.selectedPlan?.free_trial_days;
      this.planService.freeTrialText = this.selectedPlan?.free_trial_text;
      this.router.navigate(['/auth/signup'], navigationExtras);
      return;
    }
    if (this.selectedPlan.free_plan === 1 && this.selectedPlan.type_of_plan === 'normal_plan') {
      const reqObj = {
        subscription_id: this.selectedPlan.subscription_id,
      };
      this.storageService.setLocalStore('subsId', this.selectedPlan.subscription_id);
      this.subscriptionService.getFreePlanSubscription(reqObj).subscribe(res => {
        if (res) this.nextStepConditions(res);
      });
    } else {
      this.proceedPay();
    }
  }

  proceedPay() {
    this.baseService.disableFormBtnFn();
    this.storageService.setSessionStore('selectedPlanData', this.selectedPlan);
    const postData = {
      u_id: this.storageService.getLocalStore('u_id'),
      subscription_id: this.selectedPlan.subscription_id,
      stripe_plan_id: this.selectedPlan.stripe_plan_id,
      pricing_plan_id: this.selectedPlan.pricing_plan_id,
      psp_plan_id: this.selectedPlan.pricing_plan_id
    };
    this.storageService.setLocalStore('subsId', this.selectedPlan.subscription_id);
    this.selectedPlanGTM(this.selectedPlan?.plan);
    this.subscriptionService.checkOut(postData).subscribe((data) => {
      if (data) {
        this.nextStepConditions(data);
      }
    }, (error) => {
      if (error?.error?.error?.code !== 1002) {
        this.uikitService.notifyError(error);
      }
      if (error?.error?.error?.code === 2192) {
        this.router.navigateByUrl('/home')
      }
    });
  }

  nextStepConditions(data) {
    const couponMapped = this.selectedPlan.coupon_mapped || 0;
    const session_id = data.session_id;
    this.subscriptionService.paymentSessionId = session_id;
    localStorage.setItem('sessionId', session_id);
    let queryParams = { session_id };
    const discountCoupon = this.storageService.getLocalStore('discount_code');
    const discountType = this.storageService.getLocalStore('discount_type');
    const livePage = this.router.url.match('/live/');
    if (discountType === COUPON && discountCoupon) {
      if (this.router.url == R_ACCOUNT_SETTINGS || livePage?.length || this.page === 'contentDetail') {
        this.emitSelectPlan.emit({ session_id: session_id, coupon_valid: couponMapped, paymentMethods: this.paymentTypes, freePlan: this.selectedPlan?.free_plan });
      } else {
        this.router.navigate(['/voucher/method', couponMapped], { queryParams });
      }
    } else {
      const keyQueryParamTV = this.route.snapshot.queryParams['app'];
      if (keyQueryParamTV === this.baseService.keyQueryParamTV) {
        queryParams['app'] = this.baseService.keyQueryParamTV;
      } else if (keyQueryParamTV === this.baseService.keyQueryParamAppleTV) {
        queryParams['app'] = this.baseService.keyQueryParamAppleTV;
      }
      if (livePage?.length || this.router.url == R_ACCOUNT_SETTINGS || this.page === 'contentDetail') {
        this.emitSelectPlan.emit({ session_id: session_id, freePlan: this.selectedPlan?.free_plan });
      } else {
        if (this.selectedPlan.free_plan === 1) this.router.navigate(['auth/welcome']);
        else this.router.navigate(['/auth/method'], { queryParams });
      }
    }
  }

  selectedPlanGTM(plan: string): void {
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Plan Selected',
      eventLabel: plan,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') || 'False',
      region: (region ? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  checkVoucherApplied() {
    this.innerWidth = window.innerWidth;
    this.isMobileScreen = this.innerWidth < 768
    const discountCode = this.storageService.getLocalStore('discount_code');
    const discountType = this.storageService.getLocalStore('discount_type');
    // back navigation from plans page when voucher or coupon flow should be voucher page
    if ((discountType === COUPON || discountType === VOUCHER) && discountCode) {
      if (this.router.routerState.snapshot?.url === R_ACCOUNT_SETTINGS) this.backRoute = R_ACCOUNT_SETTINGS;
      else this.backRoute = window.innerWidth > 768 ? '/voucher' : '/account/m/redeem-gift-card';
    }
  }

  getSignStep($event) {
    this.emitStep.emit($event);
  }

}
